import statesDataRaw from './../components/Dashboard/Views/Customers/states'
import moment from 'moment'

export default {
  props: {
    isLoading: true
  },
  data () {
    return {
      apiResponse: [],
      statesData: statesDataRaw
      // apiRequestHeader: {
      //   'Access-Control-Allow-Origin': '*'
      // }
    }
  },
  methods: {
    getAppIsLoading () {
      return this.isLoading
    },
    setAppIsLoading (newVal) {
      this.isLoading = newVal
    },
    apiRequest (url = '/hello', method = 'GET', data = [], callback) {
      var authToken = ''
      if (data.token) {
        authToken = 'Bearer ' + data.token
      } else {
        authToken = ''
      }
      var apiRequestHeader = {
        'Access-Control-Allow-Origin': '*',
        'Authorization': authToken
      }

      const instance = this.axios.create({
        baseURL: process.env.API_BASE_URL,
        timeout: 90000, // 15 minutes
        headers: apiRequestHeader
      })

      switch (method) {
        case 'GET':
          instance.get(url, {params: data})
            .then(
              (response) => {
                if (response.data.status === false && response.data.errors.error === 'Token has expired') {
                  this.logout()
                } else {
                  callback(response.data)
                }
              }
              // ,
              // (error) => {
              //   // callback(error.data)
              // }
            )
            // .catch((error) => {
            //   // let response = {'status': false}
            //   callback(error)
            // })
          break
        case 'POST':
          instance.post(url, data)
            .then(
              (response) => {
                if (response.data.status === false && response.data.errors.error === 'Token has expired') {
                  this.logout()
                } else {
                  callback(response.data)
                }
              }
            )
          break
        case 'PUT':
          instance.put(url, data)
            .then(
              (response) => {
                if (response.data.status === false && response.data.errors.error === 'Token has expired') {
                  this.logout()
                } else {
                  callback(response.data)
                }
              }
            )
          break
        case 'DELETE':
          instance.delete(url, data)
            .then(
              (response) => {
                if (response.data.status === false && response.data.errors.error === 'Token has expired') {
                  this.logout()
                } else {
                  callback(response.data)
                }
              }
            )
          break
      }
    },
    logout () {
      this.$session.destroy()
      this.$router.push('/login')
      this.$i18n.locale = 'en'
    },
    getCompanyDetail (key) {
      var companyID = this.$session.get('selectedCompany')
      // var userData = JSON.parse(this.$session.get('userData'))
      // var defaultData = this.$session.get('defaultData')

      // var companyDetails = this.getObjectByElemKeyValue('id', companyID, userData.companies)
      // companyDetails = userData.companies[companyDetails]
      var companyDetails = this.$session.get('selectedCompanyData')

      switch (key) {
        case 'currency':
          return companyDetails.currency_iso
        case 'currency_display_format':
          return companyDetails.currency_display_format
        case 'time_format':
        case 'date_format':
          return companyDetails[key]
      }

      return ''
    },
    formatMoneyAmount (amount, currency = '', removezero = false) {
      if (currency === '') {
        currency = this.getCompanyDetail('currency')
      }
      var position = this.getCurrencyPosition(currency)
      currency = this.getCurrencySymbol(currency)
      var space = ' '

      if (removezero && amount % 1 === 0) {
        amount = Math.abs(amount)
      }
      // console.log(amount)
      // console.log(Math.abs(amount))

      if (position === 'left') {
        return currency + amount
      } else {
        return amount + space + currency
      }
    },
    getTimeFormat () {
      let format = this.getCompanyDetail('time_format')
      let formatTime = format !== '' ? format : 'H:mm'
      return formatTime
    },
    formatTime (value) {
      if (value) {
        let format = this.getCompanyDetail('time_format')
        let formatTime = format !== '' ? format : 'H:mm'
        return moment(String(value)).format(formatTime)
      }
    },
    formatDate (value) {
      if (value) {
        let format = this.getCompanyDetail('date_format')
        let formatDate = format !== '' ? format : 'DD/MM/YYYY'
        let date = moment(String(value)).format(formatDate)
        return date
      }
    },
    formatDateTime (value) {
      if (value) {
        let format1 = this.getCompanyDetail('time_format')
        let format2 = this.getCompanyDetail('date_format')
        let format = format1 + ' ' + format2
        return moment(String(value)).format(format)
      }
    },
    limitChars (text, maxLength) {
      if (text.length > maxLength) {
        return text.substring(0, maxLength) + '...'
      } else {
        return text
      }
    },
    getObjectByElemKeyValue (key, value, objects) {
      for (var index in objects) {
        if (objects[index][key] === value) {
          return index
        }
      }
      return false
    },
    getObjectByElemKeyValueBool (key, value, objects) {
      for (var index in objects) {
        if (objects[index][key] === value) {
          return true
        }
      }
      return false
    },
    isInObject (value, object) {
      for (var index in object) {
        if (parseInt(object[index]) === parseInt(value)) {
          return true
        }
      }
      return false
    },
    globalGoToRecord (row, event, column, baseUrl = '') {
      if (column.property !== 'actions' && column.property !== 'active') {
        this.$router.push(baseUrl + row.id)
      }
    },
    defaultActionDef () {
      return {
        show: false,
        colProps: {
          span: 0
        },
        def: []
      }
    },
    defaultSearchDef () {
      return {
        colProps: {
          span: 14
        }
      }
    },
    orderStatusClass (type) {
      switch (type) {
        case 'DELIVERED': return 'success'
        case 'CANCELED': return 'danger'
        case 'NOT_DELIVERED': return 'danger'
        case 'NEW': return 'info'
        case 'PROCESSING': return 'warning'
        case 'AWAITING_TRANSPORT': return 'info'
        case 'TRANSPORT': return 'info'
        default: return 'primary'
      }
    },
    orderStatusAllowed (currentSts, otherSts) {
      switch (currentSts) {
        case 'NEW':
          if (otherSts === 'NEW' || otherSts === 'PROCESSING' || otherSts === 'CANCELED') {
            return true
          } else {
            return false
          }
        default: return true
      }
    },
    feedbackTypeClass (type) {
      switch (type) {
        case 'feedback': return 'success'
        case 'issue': return 'danger'
        case 'suggestion': return 'warning'
        default: return 'info'
      }
    },
    getBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onloadend = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    getCoutryStates (country) {
      // statesList
      var countryArr = this.statesData.countries
      var stateArr = this.statesData.states
      var index = 0
      var i = 0

      for (let name of countryArr) {
        i++
        if (name === country) {
          index = i
        }
      }

      var states = stateArr[index].split('|')

      return states
    },
    getDaysLeft (date) {
      var date1 = new Date(date)
      var date2 = new Date()
      var timeDiff = date1.getTime() - date2.getTime()
      var diffDays = timeDiff / (1000 * 3600 * 24)

      return diffDays > 0 ? Math.ceil(diffDays) : 0
    },
    copyObject (o) {
      var output, v, key
      output = {} // Array.isArray(o) ? [] : {}
      for (key in o) {
        v = o[key]
        output[key] = (typeof v === 'object') ? this.copyObject(v) : v
      }
      return output
    },
    removeErrorByName (name, errors) {
      let returnErr = []
      if (errors.length) {
        for (let idx in errors) {
          if (errors[idx]['field'] !== name) {
            returnErr.push(errors[idx])
          }
        }
      }
      return returnErr
    },
    getAge (birthdate) {
      var timestamp = Math.floor(new Date().getTime() / 1000)
      return Math.floor((timestamp - moment(birthdate).format('X')) / 31556926)
    },
    getCurrencyPosition (iso) {
      var currencies = this.$session.get('defaultData')['currencies']
      var currency = this.getObjectByElemKeyValue('iso', iso, currencies)

      return currencies[currency]['symbol_position'] ? currencies[currency]['symbol_position'] : 'right'
    },
    getCurrencySymbol (iso) {
      var currencies = this.$session.get('defaultData')['currencies']
      var currency = this.getObjectByElemKeyValue('iso', iso, currencies)

      if (!currency) {
        return iso
      }

      return currencies[currency]['symbol'] ? this.decodeHtml(currencies[currency]['symbol']) : iso
    },
    decodeHtml (html) {
      var txt = document.createElement('textarea')
      txt.innerHTML = html
      return txt.value
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Inmobito.js